module.exports = __webpack_public_path__ + "img/swipe-img4.7b5c4135.png";